<template>
  <main>
    <div class="screen departures">
      <countdown-card :propFrom="from" :propTo="to"/>
    </div>
  </main>
</template>

<script>
import CountdownCard from '@/components/CountdownCard.vue'

export default {
  components: {
    CountdownCard
  },
  data() {
    return {
      from: false,
      to: false
    }
  },
  created () {
    this.to = this.$route.params.to
    this.from = this.$route.params.from
  }
}
</script>

<style lang="scss">
.screen.departures {
  padding: 0 30px;

  .box {
    position: relative;
    width: 100%;
    padding: 20px 20px 50px;
    background: #fff;
    color: #000;
    border-radius: 5px;
  }

  .display-name {
    color: #5EB4EB;
    letter-spacing: 0.2px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    padding-right: 40px;

    svg {
      margin: 0 5px;
      transform: translateY(-2px) scale(1.5);
    }
  }

  #countdown-0 {
    margin-top: 40px;
    font-size: 57px;
    letter-spacing: 1.42px;
    text-align: center;
    font-weight: 700;
  }

  .next {
    margin-top: 12px;
    font-weight: 300;
    font-size: 20px;
    color: #5EB4EB;
    letter-spacing: 0.42px;
    text-align: center;

    &.hide {
      display: none;
    }
  }

  #countdown-1 {
    font-size: 30px;
    color: #5EB4EB;
    letter-spacing: 0.52px;
    text-align: center;
  }

  #countdown-2 {
    font-size: 30px;
    color: #5EB4EB;
    letter-spacing: 0.52px;
    text-align: center;

    &.hide {
      display: none;
    }
  }

  .overview {
    position: absolute;
    bottom: -25px;
    left: 50%;
    width: 50px;
    height: 50px;
    background: #0496E7;
    border-radius: 100%;
    transform: translateX(-50%);

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18px;
      height: 2px;
      background: #fff;

      &:nth-child(1) {
        transform: translate(-50%, -5px);
      }

      &:nth-child(2) {
        transform: translate(-50%, 0);
      }

      &:nth-child(3) {
        transform: translate(-50%, 5px);
      }
    }
  }

  .return {
    position: absolute;
    // bottom: -162px;
    bottom: -80px;
    left: 50%;
    width: 50px;
    height: 50px;
    background: #F5A623;
    border-radius: 100%;
    transform: translateX(-50%);

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .return-display-name {
    display: none;
    position: absolute;
    bottom: -90px;
    left: 0;
    width: 100%;
    font-size: 13px;
    color: #fff;
    letter-spacing: 0.2px;
    font-size: 13px;
    text-align: center;

    svg {
      margin: 0 5px;

      path {
        fill: #fff;
      }
    }
  }

  .favorite {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    background: rgba(#F5A623, 0.1);
    border-radius: 5px;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &.active {
      background: rgba(#F5A623, 1);

      svg {
        path {
          stroke: #fff;
        }
      }
    }
  }
}
</style>
